/// <amd-module name="Feed/Legacy/Protocols/Common/WebApi/PackagingShared.Contracts" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://dev.azure.com/mseng/VSOnline/_wiki/wikis/VSOnline.wiki?pagePath=%2FOrphaned%20pages%2FDocQuality%2FDocQuality%252DInProgress%2FRest%20Client%20Generation
 *
 * Configuration file:
 *   packaging\client\shared\webapi\clientgeneratorconfigs\genclient.json
 */

"use strict";

/**
 * Data required for promoting multiple package versions. Pass this while performing {protocol}BatchOperationTypes.Promote batch operation.
 */
export interface BatchPromoteData {
    /**
     * Id or Name of the view, packages need to be promoted to.
     */
    viewId: string;
}

/**
 * Minimal package details required to identify a package within a protocol.
 */
export interface MinimalPackageDetails {
    /**
     * Package name.
     */
    id: string;
    /**
     * Package version.
     */
    version: string;
}

export enum PackagingSourceType {
    Public = 1,
    Internal = 2
}

/**
 * Packaging's definition of an upstream source
 */
export interface UpstreamSourceInfo {
    id: string;
    location: string;
    name: string;
    sourceType: PackagingSourceType;
}

export var TypeInfo = {
    PackagingSourceType: {
        enumValues: {
            "public": 1,
            "internal": 2
        }
    },
    UpstreamSourceInfo: <any>{
    },
};

TypeInfo.UpstreamSourceInfo.fields = {
    sourceType: {
        enumType: TypeInfo.PackagingSourceType
    }
};
